import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { ulGtpDataVolumeChartConfig } from '../chartConfigs';

/**
 * Props for the UlGtpDataVolumeEcharts component
 */
interface UlGtpDataVolumeEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Uplink GTP Data Volume Chart (LTE Site Level)
 * 
 * Displays aggregated uplink GPRS Tunneling Protocol (GTP) data volume metrics across all cells in an LTE site.
 * Shows the total volume of uplink data transmitted through the site over time.
 * 
 * This component is a thin wrapper around the SiteCharts template component,
 * configured with site-level UL data volume metrics from chartConfigs.ts
 * 
 * @component
 * @example
 * ```tsx
 * <UlGtpDataVolumeEcharts
 *   onFullscreenToggle={() => setFullscreen(!fullscreen)}
 *   isFullscreen={false}
 * />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (ulGtpDataVolumeChartConfig)
 * @see {@link ../../../components/SiteCharts.tsx} - Template component
 * @see API: /api/lte/ul-gtp-data-volume?site_name={siteName}
 */

const UlGtpDataVolumeEcharts: React.FC<UlGtpDataVolumeEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={ulGtpDataVolumeChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default UlGtpDataVolumeEcharts;
